import type { TimelineItem } from "@/types/content";
import { formatDate } from "@/utils/content";

export default function TimelineSection({ timeline }: { timeline: TimelineItem[] }) {
  return (
    <ol className="mt-6 relative border-l border-background-200 ml-2">
      {timeline.map((item) => (
        <li key={`${item.date}-${item.title}`} className="relative pl-6 md:pl-8 pb-7 last:pb-0">
          <span className="absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full bg-primary-500 border-4 border-background-50" />
          <time className="text-xs md:text-sm text-primary-500 font-medium">{formatDate(item.date)}</time>
          <h3 className="mt-1.5 font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
          <p className="mt-1.5 text-sm leading-7 text-foreground-500">{item.text}</p>
        </li>
      ))}
    </ol>
  );
}